<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Marketing</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>

        <ion-item-divider color="tertiary">
            Generate Revenue
        </ion-item-divider>
        
        <ion-item [disabled]=vb.disabled detail="true" data-test="campaigns" href="javascript:;"
                (click)="onCampaignsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Campaigns</span><br />
                <span class="line2">The current set of incentives that make up the campaign.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="customers" href="javascript:;"
                (click)="onCustomersClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Customers</span><br />
                <span class="line2">All your customers who have used your shuttle service.</span>
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">
            Campaign Settings
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="incentiveSets" href="javascript:;"
                (click)="onIncentiveSetsClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Incentive Sets</span><br />
                <span class="line2">Organize your incentives into sets to make campaign management easier.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="campaignIncentives" href="javascript:;"
                (click)="onCampaignIncentivesClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Incentives</span><br />
                <span class="line2">Define the incentives you offer your customers.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="campaignMessage" href="javascript:;"
                (click)="onCampaignMessageClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Message</span><br />
                <span class="line2">Define the opening campaign message.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="campaignHosting" href="javascript:;" 
                (click)="onCampaignHostingClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Hosting</span><br />
                <span class="line2">Where the campaign will be hosted.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="campaignFormatSelector" href="javascript:;"
                (click)="onFormatSelectorClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Campaign Format Selector</span><br />
                <span class="line2">Choose how the incentives are displayed.</span>
            </ion-label>
        </ion-item>

    </ion-list>
</ion-content>